import React from 'react'
import { formatRupee } from './Price'

// Subtotal / delivery / coupon / total card used by the cart and payment pages. `coupon` (the CouponBox) sits
// above the rows; `discount` + `couponCode` add the coupon row and `freeDelivery` strikes the delivery (the total
// from the server is already after both); `saving` = discount + waived delivery.
const OrderSummary = ({ subtotal, delivery, total, itemCount, discount, couponCode, freeDelivery, saving, coupon, children }) => {
    const deliveryAmount = Number(delivery)
    const saved = Number(discount) || 0
    const savedTotal = Number(saving) || saved
    return (
        <div className='mv-summary'>
            <h2 className='mv-summary-title'>Order summary</h2>
            {coupon}
            <dl className='mv-summary-rows'>
                <div className='mv-summary-row'>
                    <dt>Subtotal{itemCount ? ` (${itemCount} ${itemCount === 1 ? 'item' : 'items'})` : ''}</dt>
                    <dd>{formatRupee(subtotal)}</dd>
                </div>
                <div className='mv-summary-row'>
                    <dt>Delivery</dt>
                    <dd>
                        {freeDelivery && deliveryAmount > 0 && <s className='mv-summary-was'>{formatRupee(deliveryAmount)}</s>}
                        {deliveryAmount > 0 && !freeDelivery ? formatRupee(deliveryAmount) : <span className='mv-summary-free'>Free</span>}
                    </dd>
                </div>
                {saved > 0 &&
                    <div className='mv-summary-row mv-summary-discount'>
                        <dt>Coupon{couponCode ? <span className='mv-coupon-code mv-coupon-code-sm'>{couponCode}</span> : null}</dt>
                        <dd>−{formatRupee(saved)}</dd>
                    </div>}
                <div className='mv-summary-row mv-summary-total'>
                    <dt>Total</dt>
                    <dd>{formatRupee(total)}</dd>
                </div>
            </dl>
            {savedTotal > 0 && <p className='mv-summary-save'>You save {formatRupee(savedTotal)} on this order</p>}
            {children}
        </div>
    )
}

export default OrderSummary
